import { type DatabaseChangeType } from '@databases/types/redux';

import { type YJSChangeHandler } from '../../types.ts';

export const setShowFieldDescription: YJSChangeHandler<
  DatabaseChangeType.SET_SHOW_FIELD_DESCRIPTION
> = ({ ydb, change }) => {
  ydb.mutate((db) => {
    const field = db.fieldsById[change.fieldId];

    field.showDescription = change.showDescription;
  });
};
